<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}
                </router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm6>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.required('Issue Date')"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.required('Issue Date')"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="emr.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No"
                  v-model="emr.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="serialNo"
                  label="EMR No"
                  v-model="emr.serialNo"
                  type="text"
                  :rules="rules.serialNoRules"
                  :readonly="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="emr.id">
                <v-autocomplete
                  v-model="emr.status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :rules="rules.required('Status')"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="emr.shopId"
                  :items="shopList"
                  label="Choose Shop..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  color="blue-grey lighten-2"
                  :hide-no-data="true"
                  :rules="rules.required('Shop')"
                  :readonly="
                    status != 'DRAFT' || checkRoleShop() ? true : false
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="emr.departmentId"
                  :items="departmentList"
                  color="blue-grey lighten-2"
                  label="Choose Department..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Department')"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="emr.warehouseId"
                  :items="warehouseList"
                  label="Choose Warehouse..."
                  item-text="name"
                  item-value="id"
                  :hide-no-data="true"
                  menu-props="auto"
                  color="blue-grey lighten-2"
                  :rules="rules.required('Warehouse')"
                  @change="changeWarehouse"
                  :readonly="
                    status != 'DRAFT' || checkRoleWarehouse() ? true : false
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="emr.binId"
                  :items="binList"
                  label="Choose Bin..."
                  item-text="name"
                  item-value="id"
                  :hide-no-data="true"
                  menu-props="auto"
                  color="blue-grey lighten-2"
                  :rules="rules.required('Bin')"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-textarea
                  name="Reason"
                  label="Reason"
                  v-model="emr.reason"
                  counter
                  rows="2"
                  :rules="rules.reasonRules"
                  :readonly="status != 'DRAFT'"
                ></v-textarea>
              </v-flex>
              <v-flex sm6 v-if="emr.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="emr.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="emr.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="emr.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="emr.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="emr.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="showProductListDialog = !showProductListDialog"
                    :disabled="status != 'DRAFT'"
                  >
                    Add Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>

                <!-- details table -->
                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="detailCodeSearch"
                        append-icon="search"
                        placeholder="Enter product code"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="detailHeaders"
                    :items="detailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td style="text-align: left">
                        {{ props.item.productCode }}
                      </td>
                      <td style="text-align: left">
                        {{ props.item.productName }}
                      </td>
                      <td style="text-align: left">
                        {{ props.item.factorUnitName }}
                      </td>
                      <td style="text-align: right">
                        {{ props.item.qty | decFormat(6) }}
                      </td>
                      <td style="text-align: right">
                        {{ props.item.issueQty | decFormat(6) }}
                      </td>
                      <td style="text-align: right">
                        {{ props.item.unitCost | decFormat(6) }}
                      </td>
                      <td style="text-align: right">
                        {{
                          (props.item.qty * props.item.unitCost) | decFormat(6)
                        }}
                      </td>
                      <td style="text-align: left">{{ props.item.jobNo }}</td>
                      <td style="text-align: left">{{ props.item.remark }}</td>

                      <!-- actions -->
                      <td>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              flat
                              icon
                              color="blue lighten-2"
                              @click="editDetail(props.item)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="status != 'DRAFT'"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="status == 'CONFIRM'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              flat
                              icon
                              color="warning"
                              @click="
                                (showEMRUsageHistoryDialog = !showEMRUsageHistoryDialog),
                                  (selectedEmrDetailId = props.item.id)
                              "
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>info</v-icon>
                            </v-btn>
                          </template>
                          <span>Usage History</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              @click="removeDetail(props.item.id)"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="status != 'DRAFT'"
                            >
                              <v-icon>cancel</v-icon>
                            </v-btn>
                          </template>
                          <span>delete</span>
                        </v-tooltip>
                      </td>
                      <td></td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="emr.id ? true : false"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || saveLoading || status != 'DRAFT'"
                    @click="onSave()"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!--add or edit emr detail dialog-->
    <v-dialog
      v-model="emrDetailDialog"
      scrollable
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title class="blue darken-3">
          <span class="title white--text">EMR Detail</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="detailForm" v-model="detailValid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs4 pa-1>
                <v-text-field
                  name="productCode"
                  label="Product Code"
                  v-model="selectedProduct.productCode"
                  :rules="rules.codeRules"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs8 pa-1>
                <v-text-field
                  name="productName"
                  label="Product Name"
                  v-model="selectedProduct.productName"
                  :rules="rules.nameRules"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs4 pa-1>
                <v-autocomplete
                  v-model="selectedProduct.factorUnitName"
                  :hide-no-data="true"
                  :items="selectedProduct.productUnits"
                  color="blue-grey lighten-2"
                  label="Unit"
                  item-value="factorUnitName"
                  item-text="factorUnitName"
                  menu-props="auto"
                  @change="(option) => initPrice(option)"
                  :rules="rules.required('Unit')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs4 pa-1>
                <v-text-field
                  name="qty"
                  label="Qty"
                  v-model="selectedProduct.qty"
                  type="number"
                  min="0"
                  :rules="rules.geraterThanZeroQtyRules('Qty')"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 pa-1>
                <v-text-field
                  name="unitCost "
                  label="UnitCost"
                  v-model="selectedProduct.unitCost"
                  type="number"
                  min="0"
                  :rules="rules.unitCostRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="Job No"
                  label="Job No"
                  v-model="selectedProduct.jobNo"
                  :rules="rules.jobNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 pa-1>
                <v-text-field
                  name="remark"
                  label="Remark"
                  v-model="selectedProduct.remark"
                  :rules="rules.remarkRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="emrDetailDialog = !emrDetailDialog"
                  >
                    Close
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!detailValid"
                    @click="addDetail()"
                  >
                    Add
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--product list dialog-->
    <ProductListDialog
      :showDialog="showProductListDialog"
      :params="{ status: 'ACTIVE' }"
      @close="closeProductDialog"
    ></ProductListDialog>

    <!--emr usage history list dialog-->
    <EMRUsageHistoryListDialog
      :showDialog="showEMRUsageHistoryDialog"
      :params="{ emrDetailId: selectedEmrDetailId, emrNo: emr.issueNo }"
      @close="closeEMRUsageHistoryDialog"
    ></EMRUsageHistoryListDialog>
  </v-container>
</template>

<script>
import ProductListDialog from "../dialogs/ProductListDialog.vue";
import { emrService } from "../../services/emr-service";
import { EMR, EMRDetail } from "../../models/model";
import { EMRFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import { departmentService } from "../../services/department-service";
import { shopService } from "../../services/shop-service";
import { warehouseService } from "../../services/warehouse-service";
import EMRUsageHistoryListDialog from "./EMRUsageHistoryListDialog.vue";

export default {
  name: "EMRDetail",
  components: { ProductListDialog, EMRUsageHistoryListDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    detailValid: true,
    saveLoading: false,
    showEMRUsageHistoryDialog: false,
    showProductListDialog: false,
    emrDetailDialog: false,
    breadcrumbs: [
      {
        text: "EMR",
        disabled: false,
        to: "emrs",
      },
      {
        text: "EMR Detail",
        disabled: true,
      },
    ],
    emr: new EMR(),
    oldEMR: new EMR(),
    selectedProduct: new EMRDetail(),
    rules: new EMRFormRules(),
    detailHeaders: [
      { text: "Code", align: "left", sortable: false },
      { text: "Product", align: "left", sortable: false },
      { text: "Unit", align: "left", sortable: false },
      { text: "Qty", align: "right", sortable: false },
      { text: "Issue Qty", align: "right", sortable: false },
      { text: "Unit Cost", align: "right", sortable: false },
      { text: "Amount", align: "right", sortable: false },
      { text: "Job No", align: "left", sortable: false },
      { text: "Remark", align: "left", sortable: false },
      { text: "Action", align: "center", sortable: false },
    ],
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    rowsPerPageItems: [10, 50, 100],
    totalRows: 0,
    updatedDate: "",
    createdDate: "",
    issueDate: "",
    responseError: "",
    detailCodeSearch: "",
    selectedEmrDetailId: "",
    status: "DRAFT",
    departmentList: [],
    shopList: [],
    warehouseList: [],
    binList: [],
  }),
  computed: {
    detailList() {
      return this.emr.emrDetailList.filter((d) => {
        if (this.detailCodeSearch)
          return (
            d.productCode
              .toLowerCase()
              .indexOf(this.detailCodeSearch.toLowerCase()) > -1
          );
        else return true;
      });
    },
  },
  created() {
    this.emr.warehouseId = this.checkRoleWarehouse();
    this.emr.shopId = this.checkRoleShop();
    this.getShopList();
    this.getDepartmentByStatus();

    const id = this.$route.params.id;
    if (id == "new") {
      // new EMR
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      this.getActiveWarehouse().then(() => {
        if (this.emr.warehouseId) {
          this.getWarehouseBinList();
        }
      });
    } else {
      this.getEMRDetail(id);
    }
  },
  methods: {
    checkRoleWarehouse() {
      if (
        this.user.roleName == "WAREHOUSE_MANAGER" ||
        this.user.roleName == "WAREHOUSE_STAFF" ||
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.roleName == "PROCUREMENT_MANAGER"
      ) {
        return this.user.warehouseId;
      } else if (
        this.user.roleName == "SALE_MANAGER" ||
        this.user.roleName == "GENERAL_MANAGER" ||
        this.user.roleName == "SALE" ||
        this.user.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shop.warehouseId;
      }
      return "";
    },
    checkRoleShop() {
      if (
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.roleName == "SALE_MANAGER" ||
        this.user.roleName == "GENERAL_MANAGER" ||
        this.user.roleName == "PRODUCTION_MANAGER" ||
        this.user.roleName == "PROCUREMENT_MANAGER"
      ) {
        return this.user.shopId;
      }
      return "";
    },
    getActiveWarehouse() {
      return warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeWarehouse() {
      this.emr.binId = "";
      this.binList = [];
      this.getWarehouseBinList();
    },
    getWarehouseBinList() {
      if (this.user.roleName == "WAREHOUSE_STAFF") {
        this.binList = this.user.selectedBinList;
      } else {
        let warehouse = commonService.search(
          "id",
          this.emr.warehouseId,
          this.warehouseList
        );
        if (warehouse) {
          this.binList = warehouse.binList;
        }
      }
    },
    getDepartmentByStatus() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    generateId() {
      let duplicateFlag = true;
      let id;

      // generate random id until it's unique
      while (duplicateFlag) {
        id = Math.floor(Math.random() * 9999 + 1);

        // find if id is duplicated
        let duplicateDetail = this.emr.emrDetailList.find((d) => d.id == id);
        if (!duplicateDetail) duplicateFlag = false;
      }
      return id;
    },
    closeProductDialog(product) {
      if (!(JSON.stringify(product) === "{}")) {
        this.selectedProduct = new EMRDetail();
        this.selectedProduct.isNew = true;
        this.selectedProduct.id = this.generateId();
        this.selectedProduct.productId = product.id;
        this.selectedProduct.productCode = product.code;
        this.selectedProduct.productName = product.name;
        this.selectedProduct.productUnits = product.productUnits;
        var basicProductUnit = product.productUnits.find(
          (v) => v.basicUnit == true
        );
        if (basicProductUnit) {
          this.selectedProduct.productUnitId = basicProductUnit.id;
          this.selectedProduct.factorUnitName = basicProductUnit.factorUnitName;
          this.selectedProduct.unitCost = basicProductUnit.unitCost;
        }
        this.emrDetailDialog = true;
      }
      this.showProductListDialog = false;
    },
    initPrice(factorUnitName) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.selectedProduct.productUnits
      );

      this.selectedProduct.productUnitId = productUnit.id;
      this.selectedProduct.unitCost = productUnit.unitCost;
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        let emrObj = this.emr;
        emrObj.issueDateInMilliSeconds = commonService.convertToMilliseconds(
          this.issueDate
        );
        emrObj.emrDetailList.forEach((detail) => {
          if (detail.isNew) detail.id = null;
        });
        emrObj.type = "EMR";
        emrService
          .saveEMR(emrObj)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    addDetail() {
      if (this.$refs.detailForm.validate()) {
        // deep copy
        let esmDetail = JSON.parse(JSON.stringify(this.selectedProduct));
        const index = this.emr.emrDetailList
          .map((d) => d.id)
          .indexOf(esmDetail.id);
        if (index > -1) {
          this.emr.emrDetailList.splice(index, 1, esmDetail);
        } else {
          this.emr.emrDetailList.unshift(esmDetail);
        }
        this.emrDetailDialog = !this.emrDetailDialog;
      }
    },
    editDetail(emrDetail) {
      this.selectedProduct = JSON.parse(JSON.stringify(emrDetail));
      this.emrDetailDialog = true;
    },
    removeDetail(emrDetailId) {
      const index = this.emr.emrDetailList
        .map((d) => d.id)
        .indexOf(emrDetailId);

      if (!this.emr.emrDetailList[index].isNew) {
        if (!this.emr.deleteEMRDetailIds) {
          this.emr.deleteEMRDetailIds = [];
        }
        this.emr.deleteEMRDetailIds.push(emrDetailId);
      }
      this.$delete(this.emr.emrDetailList, index);
    },
    getEMRDetail(id) {
      emrService
        .getEMRDetail(id, true)
        .then((res) => {
          this.emr = res.data;
          this.status = res.data.status;
          this.createdDate = commonService.millisecondToDate(
            this.emr.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.emr.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );

          this.issueDate = commonService.millisecondToDate(
            this.emr.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.getActiveWarehouse().then(() => {
            if (this.emr.warehouseId) {
              this.getWarehouseBinList();
            }
          });
          //if unpair bin of warehouse, add in list to show in UI
          if (res.data.bin) {
            this.binList.push(res.data.bin);
          }
          //if inactive, add in list to show in UI
          if (res.data.department) {
            this.departmentList.push(res.data.department);
          }
          if (res.data.warehouse) {
            this.warehouseList.push(res.data.warehouse);
          }

          this.oldEMR = Object.assign({}, res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.emr.id) {
        this.emr = new EMR();
      } else {
        this.emr = Object.assign({}, this.oldEMR);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    closeEMRUsageHistoryDialog() {
      this.showEMRUsageHistoryDialog = false;
    },
  },
};
</script>
